var logo = "./theming/logo.svg";
var greenLogo = "./theming/greenLogo.svg";
var greenLogoStacked = "./theming/greenLogoStacked.svg";
var hero = "./theming/hero.jpg";
var profileHeroImage = "./theming/placeholder-cover-image.jpg";
var profilePicture = "./theming/placeholder-profile-picture.png";
var loaderThreeDots = "theming/three-dots.svg";
var chevronDown = "theming/icon-chevron-down.svg";
var chevronRight = "theming/icon-chevron-right.svg";
var chevronLeft = "theming/icon-chevron-left.svg";
var settings = "theming/icon-settings.svg";
var book = "theming/icon-book.svg";
var book2 = "theming/icon-book2.svg";
var document = "theming/icon-doc.svg";
var marketplace = "theming/icon-marketplace.svg";
var note = "theming/icon-note.svg";
var usergroup = "theming/icon-usergroup.svg";
var arrowRight = "theming/icon-right-arrow.svg";
var arrowLeft = "theming/icon-left-arrow.svg";
var smallArrowRight = "theming/icon-small-arrow-right.svg";
var close = "theming/icon-close.svg";
var check = "theming/icon-check.svg";
var menu = "theming/icon-menu.svg";
var menu2 = "theming/icon-menu2.svg";
var info = "theming/icon-info.svg";
var warn = "theming/icon-warn.svg";
var pencil = "theming/icon-pencil.svg";
var pencilFilled = "theming/icon-pencil-filled.svg";
var reorder = "theming/six-dots.svg";
var trash = "theming/icon-trash.svg";
var clock = "theming/icon-clock.svg";
var upload = "theming/icon-upload.svg";
var file = "theming/icon-file.svg";
var image = "theming/icon-img.svg";
var community = "theming/icon-community.svg";
var knowledgeBase = "theming/icon-knowledge-base.svg";
var lightNote = "theming/icon-light-note.svg";
var iconNotePencilGreen = "theming/icon-notepencil-green.svg";
var iconKnowledgeBaseGreen = "theming/icon-knowledgebase-green.svg";
var iconDocGreen = "theming/icon-doc-green.svg";
var designAFarm = "theming/icon-design-a-farm.svg";
var farmDesignGreenIcon = "theming/icon_farmdesign_green.svg";
var iconFb = "theming/icon-facebook.svg";
var iconTw = "theming/icon-twitter.svg";
var iconIg = "theming/icon-instagram.svg";
var iconPlaceGreen = "theming/icon-place-green.svg";
var iconPlaceGreenSolid = "theming/icon-place-green-solid.svg";
var iconPlaceGray = "theming/icon-place-gray.svg";
var iconWeb = "theming/icon-web.svg";
var iconThumbsUp = "theming/icon-thumbs-up.svg";
var iconChatBubble = "theming/icon-chat-bubble.svg";
var iconEye = "theming/icon-eye.svg";
var iconSearch = "theming/icon-search.svg";
var iconLogOut = "theming/icon-log-out.svg";
var iconFilter = "theming/icon-filter.svg";
var iconEnvelope = "theming/icon-envelope.svg";
var iconNoResults = "theming/icon-no-results.svg";
var iconMap = "theming/icon-map.svg";
var placeholderAvatar = "theming/placeholder-avatar.svg";
var imgs = {
    logo: logo,
    greenLogo: greenLogo,
    greenLogoStacked: greenLogoStacked,
    hero: hero,
    profileHeroImage: profileHeroImage,
    profilePicture: profilePicture,
    icons: {
        chevronDown: chevronDown,
        chevronLeft: chevronLeft,
        chevronRight: chevronRight,
        settings: settings,
        book: book,
        book2: book2,
        document: document,
        marketplace: marketplace,
        note: note,
        lightNote: lightNote,
        designAFarm: designAFarm,
        usergroup: usergroup,
        smallArrowRight: smallArrowRight,
        arrowRight: arrowRight,
        arrowLeft: arrowLeft,
        close: close,
        check: check,
        menu: menu,
        menu2: menu2,
        info: info,
        warn: warn,
        pencil: pencil,
        pencilFilled: pencilFilled,
        reorder: reorder,
        trash: trash,
        clock: clock,
        upload: upload,
        file: file,
        image: image,
        community: community,
        knowledgeBase: knowledgeBase,
        iconNotePencilGreen: iconNotePencilGreen,
        iconKnowledgeBaseGreen: iconKnowledgeBaseGreen,
        iconDocGreen: iconDocGreen,
        farmDesignGreenIcon: farmDesignGreenIcon,
        loaderThreeDots: loaderThreeDots,
        iconFb: iconFb,
        iconTw: iconTw,
        iconIg: iconIg,
        iconPlaceGreen: iconPlaceGreen,
        iconPlaceGreenSolid: iconPlaceGreenSolid,
        iconPlaceGray: iconPlaceGray,
        iconWeb: iconWeb,
        iconThumbsUp: iconThumbsUp,
        iconChatBubble: iconChatBubble,
        iconEye: iconEye,
        iconSearch: iconSearch,
        iconLogOut: iconLogOut,
        iconFilter: iconFilter,
        iconEnvelope: iconEnvelope,
        iconNoResults: iconNoResults,
        iconMap: iconMap,
        placeholderAvatar: placeholderAvatar,
    },
};
export default imgs;
//# sourceMappingURL=index.js.map